var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyWrap"},[_c('img',{attrs:{"src":require("../assets/image/homeImg/emptyData.png"),"alt":""}}),_vm._v(" 暂无更多内容 ")])
}]

export { render, staticRenderFns }